import { useRouter } from 'next/router';
import React from 'react';
import appConfig from 'Config';
import { useAppContext } from 'Context/ReactAppContext';
import { isStrictlyProductionEnv, isStrictlyTestEnv } from 'Utils/context/contextUtils';
import { getConfigWithNoThirdPartySupport } from './thirdParty.utils';
export const ContentSquare = () => {
  const { query: queryParams } = useRouter();
  const { isSeller, locale } = useAppContext();
  const { enabled, contentsquare } = getConfigWithNoThirdPartySupport({
    name: 'tracking',
    locale,
    queryParams,
  });

  if (
    !isStrictlyProductionEnv(appConfig) &&
    !isStrictlyTestEnv(appConfig) &&
    !isSeller &&
    enabled &&
    contentsquare.devId
  ) {
    return (
      <script
        key="contentsquare-lib"
        async
        defer
        src={`//t.contentsquare.net/uxa/${contentsquare.devId}.js`}
        type="text/javascript"
        charSet="utf-8"
      />
    );
  }

  return null;
};
